import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/PackageInfluencers.graphql';
import { Query, QuerypackageInfluencersArgs } from '../../__generated__/globalTypes';

export const usePackageInfluencersQuery = (options?: QueryHookOptions<Query, QuerypackageInfluencersArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerypackageInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const usePackageInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerypackageInfluencersArgs>
): QueryResult<Query, QuerypackageInfluencersArgs> & {
  getPackageInfluencers: LazyQueryExecFunction<Query, QuerypackageInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getPackageInfluencers, result] = useLazyQuery<Query, QuerypackageInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getPackageInfluencers, ...result };
};

export const usePackageInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getPackageInfluencers = useCallback(
    (options?: Omit<QueryOptions<QuerypackageInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QuerypackageInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getPackageInfluencers };
};
// Suspense Query Hooks
export const usePackageInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerypackageInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QuerypackageInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
